<template>
    <div id="stepOneForm" class="step-form">
        <p
            class="lead"
        >Please provide information about the production company and the location manager(s) you will be working with.</p>
        <form name="stepForm" autocomplete="off">
            <fieldset v-if="!newCompany">
                <div class="form-row">
                    <TypeaheadInput
                        ref="CompanyName"
                        inputId="CompanyName"
                        v-model.lazy="CompanyName"
                        labelText="Production company name"
                        @input="handleTypeaheadInput"
                        :isRequired="!newCompany"
                        :options="typeaheadList"
                        :wrapperClasses="['col-md-8']"
                        :disabled="companyListLoading || newCompany"
                        :loading="companyListLoading"
                        autocomplete="off"
                        aria-autocomplete="off"
                    />
                </div>

                <div class="form-row mt-3" v-if="selectedCompany && selectedCompany.CompanyName">
                    <div class="col-md-12">
                        <p>
                            <strong>{{CompanyName}}</strong>
                            <br />
                            {{CompanyAddressLine1}}
                            <template
                                v-if="CompanyAddressLine2 !== 'NO DATA PROVIDED'"
                            >
                                <br />
                                {{CompanyAddressLine2}}
                            </template>
                            <template v-if="CompanyPostalCode !== 'NO DATA PROVIDED'">
                                <br />
                                {{CompanyPostalCode}}
                            </template>
                            <template v-if="CompanyPhone !== 'NO DATA PROVIDED'">
                                <br />
                                {{CompanyPhone}}
                            </template>
                        </p>
                    </div>
                </div>
            </fieldset>

            <p>Can't find your production company in the list?</p>
            <div class="form-row">
                <CheckboxInput
                    ref="newCompany"
                    inputId="newCompany"
                    labelText="Provide information for the production company so we can add it to our list"
                    :isRequired="false"
                    v-model="newCompany"
                    :labelAfter="true"
                />
            </div>
            <fieldset class="my-4" v-show="newCompany" :disabled="!newCompany">
                <div class="form-row">
                    <TextInput
                        inputId="CompanyName"
                        labelText="Company name"
                        :wrapperClasses="['col-md-8']"
                        v-model="CompanyName"
                        :isRequired="newCompany"
                        :validation="[{type:'max',value:30,msg:'The company name must be less than 30 characters'}]"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyEmail"
                        labelText="Company email"
                        :wrapperClasses="['col-md-8']"
                        v-model.trim="CompanyEmail"
                        :isRequired="newCompany"
                        :validation="newCompany ? [{type:'email',msg:'Please provide a valid email'}] : []"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyPhone"
                        labelText="Company phone number"
                        :wrapperClasses="['col-md-8']"
                        v-model="CompanyPhone"
                        :isRequired="newCompany"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyAddressLine1"
                        labelText="Company address"
                        :wrapperClasses="['col-md-8']"
                        placeholder="Address line 1"
                        v-model="CompanyAddressLine1"
                        :isRequired="newCompany"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyAddressLine2"
                        labelText="Company address line 2"
                        :wrapperClasses="['col-md-8']"
                        placeholder="Address line 2"
                        :srOnly="true"
                        v-model="CompanyAddressLine2"
                        :isRequired="Boolean(false)"
                    />
                </div>
                <div class="form-row">
                    <SelectInput
                        inputId="CompanyProvince"
                        labelText="Province"
                        v-model="CompanyProvince"
                        :options="provinces"
                        :isRequired="!newCompany"
                    />
                    <TextInput
                        inputId="CompanyCity"
                        labelText="Company city"
                        v-model="CompanyCity"
                        :isRequired="newCompany"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyPostalCode"
                        labelText="Postal code"
                        v-model="CompanyPostalCode"
                        :isRequired="newCompany"
                    />
                </div>
            </fieldset>

            <p class="form-subheading">Location manager details</p>
            <p>This is the information you provided when you registered your account. To change this information contact the film office.</p>
            <div class="form-row">
                <div class="col-auto" v-if="!loading">
                    <p>
                        <strong>{{manager.name}}</strong>
                        <br />
                        {{manager.phone}}
                        <br />
                        {{manager.email}}
                    </p>
                </div>
                <div class="col-auto" v-else>
                    <p>Loading...</p>
                    <div class="spinner-container">
                        <div class="spinner"></div>
                    </div>
                </div>
            </div>
            <p
                class="form-label"
            >Will there be more than one location manager working on this permit?</p>
            <!--
            <div class="form-row">
                <CheckboxInput
                    inputId="manager2"
                    labelText="Provide contact information for a second location manager"
                    :isRequired="false"
                    v-model="manager2"
                    :labelAfter="true"
                />
            </div>
            -->
            <!--CHANGED: display radio input rather than checkbox above *****************-->
            <div class="form-row mb-3">
                <RadioInput
                    inputId="manager2"
                    v-model="manager2"
                    name="manager2"
                    :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                    ]"
                    :inline="false"
                    :optionalFlag="false"
                    :isRequired="false"
                />
            </div>


            <fieldset :class="{'d-none':!manager2}" :disabled="!manager2" v-show="manager2">
                <hr class="my-4" />
                <div class="form-row">
                    <TextInput
                        inputId="Manager2FirstName"
                        labelText="First name"
                        v-model="Manager2FirstName"
                        :isRequired="manager2"
                        :wrapperClasses="['col-md-4']"
                    />
                    <TextInput
                        inputId="Manager2LastName"
                        labelText="Last name"
                        v-model="Manager2LastName"
                        :isRequired="manager2"
                        :wrapperClasses="['col-md-4']"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="Manager2Email"
                        labelText="Email"
                        :wrapperClasses="['col-md-8']"
                        :validation="manager2 ? [{type:'email',msg:'Please provide a valid email'}] : []"
                        v-model.trim="Manager2Email"
                        :isRequired="manager2"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="Manager2Phone"
                        labelText="Phone number"
                        :wrapperClasses="['col-md-8']"
                        :validation="manager2 ? [{type:'phone',msg:'Please provide a valid phone number'}] : []"
                        v-model="Manager2Phone"
                        :isRequired="manager2"
                    />
                </div>
            </fieldset>
        </form>
        <div
            class="alert alert-danger mt-3"
            v-if="_errorsExist && submitted"
        >Please make sure you've filled all the fields out correctly.</div>
        <div class="d-flex justify-content-begin">
            <button id="nextStep" class="mt-3 btn btn-primary" @click="nextStep">Next</button>
        </div>
    </div>
</template>

<script>
import TypeaheadInput from "@/components/inputs/TypeaheadInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import SelectInput from "@/components/inputs/SelectInput.vue";
import RadioInput from '@/components/inputs/RadioInput.vue';
import { PROVINCES } from "@/constants/constants.js";

export default {
    name: "StepOneForm",
    components: {
        TypeaheadInput,
        CheckboxInput,
        TextInput,
        SelectInput,
        RadioInput
    },
    data() {
        return {
            step: 1,
            submitted: false,
            provinces: PROVINCES
        };
    },
    computed: {
        productionCompanies() {
            return this.$store.getters.getProductionCompanies;
        },
        companyListLoading() {
            return this.$store.getters.getProdCompanyLoadStatus;
        },
        manager() {
            const {
                FirstName,
                LastName,
                Phone,
                Email
            } = this.$store.getters.getUser;
            return {
                name: FirstName + " " + LastName,
                phone: Phone,
                email: Email
            };
        },
        manager2: {
            get() {
                return this.$store.state.newManager;
            },
            set(value) {
                //this.$store.dispatch("TOGGLE_NEW_MANAGER", value);
                this.$store.dispatch('SETSTATE_VALUE',{name:'newManager',value:value});
                if(!value)
                {
                    //clear values
                    this.Manager2FirstName='';
                    this.Manager2LastName='';
                    this.Manager2Email='';
                    this.Manager2Phone='';
                    this.submitted = false;
                }  
            }
        },
        CompanyName: {
            get() {
                return this.$store.state.formData.CompanyName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyName",
                    data: value
                });
            }
        },
        CompanyEmail: {
            get() {
                return this.$store.state.formData.CompanyEmail;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyEmail",
                    data: value
                });
            }
        },
        CompanyPhone: {
            get() {
                return this.$store.state.formData.CompanyPhone;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyPhone",
                    data: value
                });
            }
        },
        CompanyAddressLine1: {
            get() {
                return this.$store.state.formData.CompanyAddressLine1;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyAddressLine1",
                    data: value
                });
            }
        },
        CompanyAddressLine2: {
            get() {
                return this.$store.state.formData.CompanyAddressLine2;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyAddressLine2",
                    data: value
                });
            }
        },
        CompanyCity: {
            get() {
                return this.$store.state.formData.CompanyCity;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyCity",
                    data: value
                });
            }
        },
        CompanyProvince: {
            get() {
                return this.$store.state.formData.CompanyProvince;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyProvince",
                    data: value
                });
            }
        },
        CompanyPostalCode: {
            get() {
                return this.$store.state.formData.CompanyPostalCode;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyPostalCode",
                    data: value
                });
            }
        },
        newCompany: {
            get() {
                return this.$store.getters.newProductionCompany;
            },
            set(event) {
                this.$store.dispatch("TOGGLE_NEW_PROD_COMPANY", event);
            }
        },
        Manager2FirstName: {
            get() {
                return this.$store.state.formData.Manager2FirstName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2FirstName",
                    data: value
                });
            }
        },
        Manager2LastName: {
            get() {
                return this.$store.state.formData.Manager2LastName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2LastName",
                    data: value
                });
            }
        },
        Manager2Email: {
            get() {
                return this.$store.state.formData.Manager2Email;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2Email",
                    data: value
                });
            }
        },
        Manager2Phone: {
            get() {
                return this.$store.state.formData.Manager2Phone;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2Phone",
                    data: value
                });
            }
        },
        typeaheadList() {
            return this.productionCompanies.map(company => company.CompanyName);
        },
        selectedCompany() {
            if (this.CompanyName) {
                return this.productionCompanies.filter(
                    company => company.CompanyName == this.CompanyName
                )[0];
            } else {
                return {
                    CompanyName: "",
                    CompanyEmail: "",
                    CompanyPhone: "",
                    CompanyAddressLine1: "",
                    CompanyAddressLine2: "",
                    CompanyCity: "",
                    CompanyProvince: "",
                    CompanyPostalCode: ""
                };
            }
        },
        loading() {
            return this.$store.getters.isLoading;
        }
    },
    methods: {
        nextStep() {
            this.submitted = true;
            if (!this._errorsExist()) {
                this.$store.dispatch("COMPLETE_STEP", {
                    step: this.step,
                    complete: true
                });
            }
        },
        handleTypeaheadInput(e) {
            var selectedCompany = this.productionCompanies.filter(
                company => company.CompanyName == e
            )[0];

            if (typeof selectedCompany == "object") {
                Object.keys(selectedCompany).map(field => {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: field,
                        data: selectedCompany[field]
                    });
                });
            }
        }
    },
    mounted() {
        document.getElementById("stepOneForm").focus();
        this.newCompany = this.$store.getters.newProductionCompany;
    }
};
</script>
